import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"10px"} }
const _hoisted_2 = { style: {"margin-left":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 预 览 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编 辑 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 删 除 ")

import { unref, reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';

import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';

import { useDictionary } from '@/store/dictionary.store';
import { findIndex, formatTools } from '@/utils';
import { Session } from '@/utils/storage';
import { config } from '@/config/config';
import { GetMaterialListApi } from '@/apis/contract/contract.draft.api';
import { DelMaterialsApi } from '@/apis/materials/material.api';
// import PdfViewDialog from './pdfViewDialog.vue';
import PdfViewDialog from '@/views/contracts/editors/components/pdfViewDialog.vue'
import { propTypes } from '@/utils/propTypes'


export default /*#__PURE__*/_defineComponent({
  props: {
  tableKey: propTypes.string.def(''),
},
  setup(__props, { expose }) {

const props = __props



const pdfViewRef = ref<InstanceType<typeof PdfViewDialog>>();

const dicStore = useDictionary();
const { register, tableObject } = useGbTable();
const { fDateTime } = formatTools();
const { base_url } = config;
const { resolve, getRoutes } = useRouter();
const tbk = props.tableKey

const tabColumns = reactive<any[]>([
	{ field: 'file_name', label: '文件名称' },
	{ field: 'material_type_desc', label: '分类', columnWidth: '100', align: 'center' },
	{ field: 'file_suffix', label: '文件类型', columnWidth: '80', headerAlign: 'center', align: 'center' },
	{ field: 'file_size', label: '文件大小', columnWidth: '120', headerAlign: 'center', align: 'right' },
	{ field: 'curr_version', label: '当前版本', columnWidth: '80', align: 'center' },
	{ field: 'created_user_id', label: '上传用户', columnWidth: '120', align: 'center' },
	{ field: 'created_time', label: '上传时间', columnWidth: '120', align: 'center' },
	{ field: 'action', width: '180px', label: '操作', fixed: 'right', align: 'center' },
]);

const state = reactive({
	load: false,
	materialTypeList: [] as any[],
});

onMounted(() => {
  console.log('66600',props.tableKey)
  console.log('66600',tbk)
  state.materialTypeList = dicStore.getSelectList('material_type');

  const defType = state.materialTypeList.filter((tp: any) => tp.label == '其他附件') || [];
  if (defType.length == 1) {
    unref(upSchema).material_type = defType[0].value;
    unref(upSchema).material_type_desc = defType[0].label;
  }
  unref(upSchema).table_key = props.tableKey

  const tokenStr = Session.get('token') as string;
  const token = (str: any) => {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  };
  uploads.headers.Authorization = `Bearer ${token(tokenStr)}`;
});

// const $props = defineProps({
//   tableKey: { type: String, default: () => '' },
// });



const actions = {
	showEdit: (row: any) => {
		if (row && row.file_suffix) {
			return ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0;
		} else {
			return false;
		}
	},
	/* 文件预览 */
	preview: (row: any) => {
		/* .pdf文件避免使用OnlyOffice打开，因为pdf文件有可能引发不可预料的错误 */
		if (row.file_suffix != '.pdf') {
			/* 如果是office系文件，则使用onlyoffice打开 */
			const isOfficeFile = ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0;
			if (isOfficeFile) {
				let urls = resolve({ path: `/onlyoffices/docview/${row.id}/1` });
				window.open(urls.href, '_blank');
			} else {
			}
		} else {
			unref(pdfViewRef)?.openDialog(row);
		}
	},
	/* 修改文件 */
	editors: (row: any) => {
		let urls = resolve({ path: `/onlyoffices/doceditor/${row.id}/1` });
		window.open(urls.href, '_blank');
	},
	/* 删除某个附件 */
	deleteFile: (row: any) => {
		const rowIndex = findIndex<any>(tableObject.tableList, (t: any) => {
			return t.id == row.id;
		});

		if (rowIndex < 0) return;

		const delData = {
			id: row.id,
			revision: row.revision,
		};

		ElMessageBox.confirm('是否删除选中的数据？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', lockScroll: false }).then(async () => {
			await DelMaterialsApi(delData).then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`附件删除失败，原因：${res.errors}`);
				} else {
					ElMessage.success(`删除成功。`);

					tableObject.tableList.splice(rowIndex, 1);
				}
			});
		});
	},
};




const upSchema = ref<any>({
	categroy_id: 'b2587d6d-6f04-4b0f-817a-cc444abab7fe', // 固定这个分类
	ct_num: '',
	material_type: '',
	material_type_desc: '',
  table_key: ''
});



/* 上传组件设置 */
const uploads = {
	urls: `${base_url}/api/sysmaterial/uploadfile`,
	headers: {
		Authorization: '',
	},
	onUploadSuccess: (res: IResponse, file: any) => {
		if (!res.succeeded) {
			ElMessage.error(`文件上传失败，可能的原因是：${res.errors}`);
		} else {
			ElMessage.success('上传成功');
			tableObject.tableList.push(res.data);
		}
	},
};

const changes = {
	materialtype: (val: any) => {
		unref(upSchema).material_type_desc = dicStore.getName('material_type', val) || '--';
	},
};





const methods = {
	getFileList: () => {
		return tableObject.tableList.map((file: any) => file.id);
	},
	/* 获取付款申请关联附件记录 */
	setFileList: async (billID: string) => {
		state.load = true;
		const { succeeded, errors, data } = await GetMaterialListApi(billID);
		state.load = false;

		if (!succeeded) {
			ElMessage.error(`读取付款计划列表数据出错，可能的原因是：${errors}`);
		} else {
			tableObject.tableList = data || [];
		}
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_upload, {
        data: upSchema.value,
        action: uploads.urls,
        headers: uploads.headers,
        "show-file-list": false,
        "on-success": uploads.onUploadSuccess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["data", "action", "headers", "on-success"])
    ]),
    _createVNode(_unref(GbTables), {
      data: _unref(tableObject).tableList,
      columns: _unref(tabColumns),
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      created_time: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
      ]),
      material_type_desc: _withCtx(({ row }) => [
        _createVNode(_component_el_tag, {
          size: "small",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(row.material_type_desc), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      action: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          link: "",
          onClick: ($event: any) => (actions.preview(row))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (actions.showEdit(row))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              type: "success",
              link: "",
              onClick: ($event: any) => (actions.editors(row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          size: "small",
          type: "danger",
          link: "",
          onClick: ($event: any) => (actions.deleteFile(row))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["data", "columns", "onRegister"]),
    _createVNode(PdfViewDialog, {
      ref_key: "pdfViewRef",
      ref: pdfViewRef
    }, null, 512)
  ], 64))
}
}

})